import { FC, PropsWithChildren, ReactElement, cloneElement } from 'react';

import { SkeletonFeed } from './SkeletonFeed/SkeletonFeed';
import { SkeletonVariant } from './Skeleton.types';
import { SkeletonList } from './SkeletonList/SkeletonList';
import { SkeletonArticle } from './SkeletonArticle/SkeletonArticle';
import { SkeletonDocument } from './SkeletonDocument/SkeletonDocument';

const MAP: Record<SkeletonVariant, ReactElement> = {
  article: <SkeletonArticle />,
  list: <SkeletonList />,
  feed: <SkeletonFeed />,
  document: <SkeletonDocument />,
};

export type SkeletonProps = PropsWithChildren<{
  loading: boolean;
  variant: keyof typeof MAP;
  count?: number;
}>;

export const Skeleton: FC<SkeletonProps> = ({
  children,
  variant,
  loading,
  count = 3,
}) => {
  if (loading) {
    return cloneElement(MAP[variant], { count });
  }

  return <>{children}</>;
};
